import styled from 'styled-components';

export const StyledPreviewContainer = styled.div`
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  height: 100%;
  .live-preview-content {
    img {
      max-width: 100%;
      object-fit: contain;
    }
  }
`;

export const StyledPage = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 4px 12px 0px #e7eaf6;
  border-radius: 4px;
  padding: 32px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const TitleContainer = styled.div`
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  h5 {
    opacity: 0.2;
    color: '#0B1A30';
  }
`;

export const AvatarContainer = styled.div`
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  img {
    width: 76px !important;
    height: 76px !important;
    border-radius: 8px;
    object-fit: cover;
  }
  span {
    padding: 20px 0 16px;
    font-weight: bold;
    color: #0b1a30;
    opacity: 0.4;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SignatureContainer = styled.div`
  padding: 0 24px;
  width: 148px;
  border-bottom: 1px solid #dbdde2;
  margin-bottom: 4px;
`;
